<template>
  <div class="housing-locality-apartments print-break-before">

      <div class="drawer">
          <h2 class="h2 text-align-center mb-5">
            {{translate('Vapaana olevat asunnot')}}
          </h2>
      </div>

      <div v-if="!loading" class="filter-container">
        <ItemListFilterRooms
          v-if="apartments.length > 6"
          v-model="selectedRoomCounts"
          :label="translate('Huoneita')"
          :apartments="apartments"
        />
        <InputCheckbox
          v-if="isNewHousingLocality && apartments.length > 0"
          v-model="showFloorplan"
          class="floorplan-checkbox"
          :label="translate('Näytä pohjakuvat')"
        >
          {{ translate('Näytä pohjakuvat') }}
        </InputCheckbox>
      </div>

      <LoadSpinner v-if="loading"/>

      <div
          v-if="apartments.length > 0"
          class="apartment-search-full__grid listing-card-grid"
        >
          <div class="listing-card-grid__grid narrow-grid">
            <div
              v-for="apartment in visibleApartments"
              class="listing-card-grid__column"
              :key="apartment.id"
            >
              <ApartmentCard
                :apartment="apartment"
                :show-floorplan="showFloorplan"
                class="listing-card-grid__item"
              />
            </div>
          </div>
        </div>
        <div v-if="!loading && filteredApartments.length == 0"
          class="listing-not-found"
        >
            {{translate('Vapaita asuntoja ei löytynyt')}}
        </div>

        <div
          class="apartment-search-full__load-more-container print-hide"
        >
          <button
            v-if="apartmentsVisible < filteredApartments.length"
            class="apartment-search-full__load-more btn"
            :class="`btn--green`"
            @click="apartmentsVisible += step"
          >
              {{translate('Katso lisää vapaita asuntoja')}}
          </button>
        </div>

  </div>
</template>

<script>
  import axios from 'axios';

  import globals from '../lib/globals';
  import utils from './mixins/utils';
  import LoadSpinner from './components/LoadSpinner';
  import ApartmentCard from './components/ApartmentCard';
  import ItemListFilterRooms from './components/ItemListFilterRooms';
  import InputCheckbox from './components/InputCheckbox';

  export default {
    components: {
      LoadSpinner,
      ApartmentCard,
      ItemListFilterRooms,
      InputCheckbox,
    },
    mixins: [
      utils.translate,
    ],
    props: {
      housingLocality: {
        type: String,
        required: true,
      },
      isNewHousingLocality: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loading: false,
        apartments: [],
        apartmentsVisible: 6, // Number of apartments to show initially
        step: 6, // Number of apartments to load per step/page
        selectedRoomCounts: [], // Selected room counts for filtering
        showFloorplan: this.isNewHousingLocality, // Show floorplans by default for new housing localities
      };
    },
    watch: {
      selectedRoomCounts() {
        this.apartmentsVisible = this.step;
      },
    },
    computed: {
      filteredApartments() {
        // If no filter selected, return all
        if (this.selectedRoomCounts.length === 0) {
          return this.apartments;
        }

        return this.apartments.filter(apt => {
          // Ensure room_count is a number
          const aptRooms = Number(apt.room_count);

          return this.selectedRoomCounts.some(selectedOption => {
            if (selectedOption === 5) {
              return aptRooms >= 5; // 5+ logic
            } else {
              return aptRooms === selectedOption; // Exact match 1, 2, 3, 4
            }
          });
        });
      },
      visibleApartments() {
        return this.filteredApartments.slice(0, this.apartmentsVisible)
      }
    },
    async beforeMount() {
      this.loading = true;
      try {
        const url = `${globals.urlIntegrationApi}/public/available-apartments-by-housing-locality/${this.housingLocality}`;
        const response = await axios.get(url);
        let apartments = (response && response.data) ? response.data : [];

        this.apartments = apartments.sort((a, b) => {
          const aArea = a.mpc_pinta_ala;
          const bArea = b.mpc_pinta_ala;
          return aArea === bArea ? 0 : (aArea < bArea ? -1 : 1);
        });
      } catch (e) {
        console.error("Error while fetching housing locality apartments.", e);
        this.apartments = [];
      }

      this.loading = false;
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    margin-bottom: 2rem;

    @include media-breakpoint-down(sm) {
      flex-direction: column;
      align-items: flex-start;
    }

    .floorplan-checkbox {
      margin-left: auto;

      @include media-breakpoint-down(sm) {
        margin-left: 0;
        margin-top: 1.5rem;
      }
    }
  }

  .narrow-grid .listing-card-grid__column {
    display: flex;
    padding: 0 r(12) r(20);
    width: 100%;

    @include media-breakpoint-up(md) {
      width: 50%;
    }

    @include media-breakpoint-up(xl) {
      width: 33.3%;
    }
  }
  .listing-not-found {
    font-size: $ff-lato;
    padding-left: r(8);
    text-align: center;
  }

  .drawer__header.drawer__header-no-border {
    border-bottom-color: transparent;
  }

</style>
